import React from "react";
import withAuthenticationRequired from './with-authentication-required';
import { LoadingPage } from "./components/LoadingPage";

export const ProtectedRoute = ({ component }) => {
    const Component = withAuthenticationRequired(component, {
        onRedirecting: () => (
          <LoadingPage />
        ),
    });

    return <Component />
}
